/*
* author: liujianhong
* mail: 64617842@qq.com
* */
import { ajax, authorURL } from '@/utils/request';

const api = {
    //公共API
    // 登录
    loginFn(username: string, password: string, validatecode: string) {
        return ajax({
            method: 'post',
            url: authorURL + `login?username=${username}&password=${password}&validatecode=`,
            isAuthRequest: true
        });
    },
    // 获取token
    getToken(tenantCode: string) {
        return ajax({
            method: 'get',
            url: authorURL + `oauth/authorize/industrial-web-api?tenantCode=${tenantCode}`,
            withCredentials: true,
            isAuthRequest: true
        });
    },
    //数据字典
    getDir(query: string) {
        return ajax({
            method: 'get',
            url: `dict-data-mgt/datas/${query}`
        });
    },
    //获取当前登录用户
    getCurrentUserMenu(query: string) {
        return ajax({
            method: 'get',
            url: `menu-mgt/user/${query}/menu/ROOT_PARENT`
        });
    },
    //获取用户权限
    getPermissionByUser(userCode: string) {
        return ajax({
            method: 'get',
            url: `role-mgt/permission/${userCode}`
        })
    },
    //查询所有省级
    getProvinceData() {
        return ajax({
            method: 'get',
            url: `area-mgt/province`
        });
    },
    //查询所有市级
    getCityData(query: string) {
        return ajax({
            method: 'get',
            url: `area-mgt/${query}/city`
        });
    },
    //查询所有区级
    getAreaData(query: string) {
        return ajax({
            method: 'get',
            url: `area-mgt/${query}/district`
        });
    },
    //获取二进制文件流
    getFileBinary(query: string) {
        return ajax({
            method: 'get',
            url: `public/file/${query}`
        });
    },

    // 首页流程查询
    getIndexProcess(data: any) {
        return ajax({
            method: 'get',
            url: `index/process`,
            data
        });
    },

    // 首页日常事务列表查询
    getDailyWorkList(data: any) {
        return ajax({
            method: 'get',
            url: `daily/list`,
            data
        });
    },

    // 全部应用统计
    workbenchTodoCount() {
        return ajax({
            method: 'get',
            url: `index/todo-count`,
        });
    },

    // 获取所有工作台流程类型
    getWorkbenchCategorys() {
        return ajax({
            method: 'get',
            url: `process-category-mgt/categorys`,
        });
    },

    // 新增快捷入口
    addQuickAccess(data: any) {
        return ajax({
            method: 'post',
            url: `quick-access-mgt/quick`,
            data
        });
    },
    // 移除快捷入口
    deleQuickAccess(id: any) {
        return ajax({
            method: 'delete',
            url: `quick-access-mgt/quick/${id}`,
        });
    },
    // 获取当前用户没有的快捷入口
    getHasNotQuickAccess() {
        return ajax({
            method: 'get',
            url: `quick-access-mgt/exist`,
        });
    },
    // 获取当前用户的快捷入口
    getHasQuickAccess() {
        return ajax({
            method: 'get',
            url: `quick-access-mgt/quick`,
        });
    },

    // 创建日常事务
    dailyCreate(data: any) {
        return ajax({
            method: 'post',
            url: `daily/create`,
            data
        });
    },
    // 获取日常事务详情
    dailyDetail(id: any) {
        return ajax({
            method: 'get',
            url: `daily/get/${id}`,
        });
    },
    // 处理日常事务
    dailyHandle(data: any) {
        return ajax({
            method: 'post',
            url: `daily/handle`,
            data
        });
    },
    // 修改日常事务
    dailyUpdate(data: any) {
        return ajax({
            method: 'post',
            url: `daily/update`,
            data
        });
    },
    // 优秀案例分享
    superCaseList(data: any) {
        return ajax({
            method: 'get',
            url: `study-mgt/study`,
            data
        });
    },

    //查询文件详情
    getFileDetail(id: any) {
        return ajax({
            method: 'get',
            url: `file/info/${id}`
        });
    },
    //获取日常列表
    getDailyList(data: any) {
        return ajax({
            method: 'get',
            url: `daily/list`,
            data
        });
    },
    //获取日常详情
    getDailyDetails(id: any) {
        return ajax({
            method: 'get',
            url: `daily/get/${id}`,
        });
    },
    //修改日常事务
    updateDailyInfo(data: any) {
        return ajax({
            method: 'post',
            url: `daily/update`,
            data
        });
    },

    // 移除合同
    removeContractApply(id: any) {
        return ajax({
            method: 'DELETE',
            url: `contract-apply/${id}`,
        });
    },

    // 移除合同
    removePaymentMgt(id: any) {
        return ajax({
            method: 'DELETE',
            url: `payment-mgt/${id}`,
        });
    },

    // 移除采购申请
    removePurchaseMgt(id: any) {
        return ajax({
            method: 'DELETE',
            url: `purchase-mgt/${id}`,
        });
    },

    // 材料总计划
    removeMaterialTotalMgt(id: any) {
        return ajax({
            method: 'DELETE',
            url: `material-total-plan-mgt/${id}`,
        });
    },

    // 移除材料分批计划
    removeMaterialSubMgt(id: any) {
        return ajax({
            method: 'DELETE',
            url: `material-sub-plan-mgt/${id}`,
        });
    },

    // 移除开票申请
    removeInvoice(id: any) {
        return ajax({
            method: 'DELETE',
            url: `invoice-mgt/${id}`,
        });
    },

    // 移除奖惩申请
    removeRewardPunishmentsMgt(id: any) {
        return ajax({
            method: 'DELETE',
            url: `reward-punishments-mgt/${id}`,
        });
    },

    // 移除材料询价审核
    removeInquiryMgt(id: any) {
        return ajax({
            method: 'DELETE',
            url: `inquiry-mgt/${id}`,
        });
    },

    // 移除借款
    removeBorrowing(id: any) {
        return ajax({
            method: 'DELETE',
            url: `borrowing-mgt/${id}`,
        });
    },

    // 移除报销申请
    removeReimbursementMgt(id: any) {
        return ajax({
            method: 'DELETE',
            url: `reimbursement-mgt/${id}`,
        });
    },

    // 移除用章申请
    removeSeal(id: any) {
        return ajax({
            method: 'DELETE',
            url: `seal-mgt/${id}`,
        });
    },

    // 移除请假申请
    removeLeave(id: any) {
        return ajax({
            method: 'DELETE',
            url: `leave-mgt/${id}`,
        });
    },

    // 移除请假申请
    removeTravel(id: any) {
        return ajax({
            method: 'DELETE',
            url: `travel-mgt/${id}`,
        });
    },

    // 移除通用流程申请
    removeCommon(id: any) {
        return ajax({
            method: 'DELETE',
            url: `common-flow-mgt/${id}`,
        });
    },

    // 移除办公用品采购申请
    removeOfficePurchase(id: any) {
        return ajax({
            method: 'DELETE',
            url: `office-purchase-mgt/${id}`,
        });
    },

    // 移除通用流程申请
    removeOfficeUse(id: any) {
        return ajax({
            method: 'DELETE',
            url: `office-use-mgt/${id}`,
        });
    },

    // 周报报表导出
    exportWork(data: any) {
        return ajax({
            method: "get",
            url: `work-mgt/report-export`,
            type: "blob",
            data,
        });
    },

    // 
    getOfficeUseSupplies(data: any) {
        return ajax({
            method: "get",
            url: `office-out-mgt/use-supplies`,
            data,
        });
    },
    // 撤销-出差申请
    revokeTravel(id:any, remark:any){
        return ajax({
            method: "put",
            url: `travel-mgt/undo/${id}?remark=${remark}`,
        });
    },
    // 撤销-办公用品采购
    revokeOfficePurchase(id:any, remark:any){
        return ajax({
            method: "put",
            url: `office-purchase-mgt/undo/${id}?remark=${remark}`,
        });
    },
    // 撤销-办公用品领用
    revokeOfficeUse(id:any, remark:any){
        return ajax({
            method: "put",
            url: `office-use-mgt/undo/${id}?remark=${remark}`,
        });
    },
    // 撤销-开票申请
    revokeInvoice(id:any, remark:any){
        return ajax({
            method: "put",
            url: `invoice-mgt/undo/${id}?remark=${remark}`,
        });
    },
    // 撤销-用章申请
    revokeSeal(id:any, remark:any){
        return ajax({
            method: "put",
            url: `seal-mgt/undo/${id}?remark=${remark}`,
        });
    },
    // 撤销-请假申请
    revokeLeave(id:any, remark:any){
        return ajax({
            method: "put",
            url: `leave-mgt/undo/${id}?remark=${remark}`,
        });
    },
    // 撤销-通用流程申请
    revokeCommon(id:any, remark:any){
        return ajax({
            method: "put",
            url: `common-flow-mgt/undo/${id}?remark=${remark}`,
        });
    },
    // 撤销-材料总计划
    revokeMaterialTotalPlan(id:any, remark:any){
        return ajax({
            method: "put",
            url: `material-total-plan-mgt/undo/${id}?remark=${remark}`,
        });
    },
    // 撤销-材料分批计划
    revokeMaterialSubPlan(id:any, remark:any){
        return ajax({
            method: "put",
            url: `material-sub-plan-mgt/undo/${id}?remark=${remark}`,
        });
    },
    // 撤销-采购申请
    revokePurchase(id:any, remark:any){
        return ajax({
            method: "put",
            url: `purchase-mgt/undo/${id}?remark=${remark}`,
        });
    },
    // 撤销-付款申请
    revokePayment(id:any, remark:any){
        return ajax({
            method: "put",
            url: `payment-mgt/undo/${id}?remark=${remark}`,
        });
    },
    // 撤销-材料询价
    revokeInquiry(id:any, remark:any){
        return ajax({
            method: "put",
            url: `inquiry-mgt/undo/${id}?remark=${remark}`,
        });
    },
    // 撤销-借款申请
    revokeBorrowing(id:any, remark:any){
        return ajax({
            method: "put",
            url: `borrowing-mgt/undo/${id}?remark=${remark}`,
        });
    },
    // 撤销-报销申请
    revokeReimbursement(id:any, remark:any){
        return ajax({
            method: "put",
            url: `reimbursement-mgt/undo/${id}?remark=${remark}`,
        });
    },
    // 撤销-合同申请
    revokeContractApply(id:any, remark:any){
        return ajax({
            method: "put",
            url: `contract-apply/undo/${id}?remark=${remark}`,
        });
    },
    // 撤销-奖惩
    revokeRewardPunishments(id:any, remark:any){
        return ajax({
            method: "put",
            url: `reward-punishments-mgt/undo/${id}?remark=${remark}`,
        });
    },
    // 工作流-退回指定节点
    backToTask(data:any){
        return ajax({
            method: "post",
            url: `process-task-mgt/backToTask`,
            data
        });
    },
    // 材料来源
    getMaterialSourceList(){
        return ajax({
            method: "get",
            url: `material-source-category-mgt/category`,
        });
    },
}
export default api;
